export const PACKAGE_NAME = 'jiraServicedeskKnowledgeHub';
export const TEAM_NAME = 'JSM nebula';
